import axios from 'axios';
import axiosRetry from 'axios-retry';
import jwtDefaultConfig from './jwtDefaultConfig'
import environment from "environment";
import { showLoader } from '../../views/pages/probate/globalstore'

const isNetworkError = (error) =>
  error && // just to make sure
  !error.response && // if there is a response, it reached the server and not a network error
  error.code !== 'ECONNABORTED';

axiosRetry(axios, {
  retries: 1, // number of retries
  retryDelay: (retryCount) => {
    // console.debug(`retry attempt: ${retryCount}`);
    return retryCount * 10000; // time interval between retries
  },
  retryCondition: (error) => {

    // if retry condition is not specified, by default idempotent requests are retried
    return isNetworkError(error) || error.response.status === 503;
  },
});

export default class JwtService {
  // ** jwtConfig <= Will be used by this service

  jwtConfig = { ...jwtDefaultConfig }
  // ** For Refreshing Token
  isAlreadyFetchingAccessToken = false
  unAuthRoutes = ["/docassemble_proxy/create_user", "/docassemble_proxy/loginurl"]
  // ** For Refreshing Token
  subscribers = []
  store;
  notify;

  constructor(jwtOverrideConfig, store, notify) {
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }
    this.store = store;
    this.notify = notify;

    // ** Request Interceptor
    axios.interceptors.request.use(
      (config) => {
        // ** Get token from localStorage
        const accessToken = this.getToken();

        ((accessToken && accessToken !== "null") || this.unAuthRoutes.some(o => config.url === o)) &&
          this.store && this.store.dispatch(showLoader(true));
        // ** If token is present add it to request's Authorization Header
        if (accessToken?.token) {
          // ** eslint-disable-next-line no-param-reassign
          if (config.headers)
            config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken.token}`
        }
        return config
      },
      error => Promise.reject(error)
    )

    // ** Add request/response interceptor
    axios.interceptors.response.use(
      response => {
        this.store && this.store.dispatch(showLoader(false));

        if (window.location.href.startsWith(environment.baseurl) 
            && response.request.responseURL.indexOf('softrestart') !== -1 
            && window.location.search.indexOf("softrestart") === -1
            ) {
          let url = new URL(window.location.href); 
          url.searchParams.append('softrestart', 'Y');
          window.location.href = url.toString();
        }

        return response
      },
      error => {
        // ** const { config, response: { status } } = error
        const { config, response } = error
        const originalRequest = config

        this.store && this.store.dispatch(showLoader(false));

        const sessionExpired = () => {
          this.notify("Session Expired!", "error");
          localStorage.removeItem("userData");
          setTimeout(o => { window.location.href = "/probate/assertion"; }, 2000);
        }
        // ** if (status === 401) {
        if (response && response.status === 401) {
          sessionExpired();
          if (!this.isAlreadyFetchingAccessToken) {
            this.isAlreadyFetchingAccessToken = true
            // this.refreshToken().then(r => {
            //   this.isAlreadyFetchingAccessToken = false

            //   // ** Update accessToken in localStorage
            //   this.setToken(r.data.accessToken)
            //   this.setRefreshToken(r.data.refreshToken)

            //   this.onAccessTokenFetched(r.data.accessToken)
            // })
          }
          // const retryOriginalRequest = new Promise(resolve => {
          //   this.addSubscriber(accessToken => {
          //     // ** Make sure to assign accessToken according to your response.

          //     // ** Change Authorization header
          //     originalRequest.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
          //     resolve(this.axios(originalRequest))
          //   })
          // })
          // return retryOriginalRequest
        } 
        else if (response && response.status === 302) {

        }
        else if (isNetworkError(error)) {
          this.notify("Please check your internet connection and try again", "error");
        } 
        else {
          console.error("Interceptor Response Error: ", response);
          this.notify(response?.data?.ErrorMessage ?? "An error occurred while processing your request. Please contact administrator after 3 retries.", "error");
        }
        return Promise.reject(error)
      }

    )
  }


  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter(callback => callback(accessToken))
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }

  getToken() {
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName)
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName)
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value)
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value)
  }

  login(...args) {
    return axios.post(this.jwtConfig.loginEndpoint, ...args)
  }

  register(...args) {
    return axios.post(this.jwtConfig.registerEndpoint, ...args)
  }

  refreshToken() {
    return axios.post(this.jwtConfig.refreshEndpoint, {
      refreshToken: this.getRefreshToken()
    })
  }
}

